<template>
    <div id="app-logo">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 105.2 29.6" style="enable-background:new 0 0 105.2 29.6;" xml:space="preserve">
            <g id="logo-mark">
              <path class="st1" d="M36.9,11.8c-0.3-1-0.8-1.8-1.3-2.6c-1.2-1.9-3.5-3.7-5.8-5.3c-2.5-1.7-5.2-3-6.7-3.7C22.8,0.1,22.6,0,22.4,0
                c-0.1,0-0.3,0-0.4,0.1c-0.4,0.1-0.7,0.4-0.8,0.7c-0.4,0.7-0.9,1.7-1.4,2.8c-0.5,1.1-1.1,2.4-1.6,3.8L18,7.7
                c-2.6-2.9-6.9-4.1-10.9-2.8c-4,1.3-6.7,4.8-7.1,8.7c-0.2,1.5,0,2.9,0.4,4.4c0.3,1,0.8,1.8,1.3,2.6c1.2,1.9,3.5,3.7,5.8,5.3
                c2.5,1.7,5.2,3,6.7,3.7c0.2,0.1,0.5,0.1,0.7,0.1c0.1,0,0.2,0,0.3,0c0.4-0.1,0.7-0.4,0.8-0.7c0.4-0.7,0.9-1.7,1.4-2.8
                c0.5-1.1,1.1-2.4,1.6-3.8c0.1-0.2,0.1-0.3,0.2-0.5c2.7,2.9,6.9,4.2,11,2.9c4-1.3,6.7-4.8,7.2-8.7C37.5,14.7,37.4,13.2,36.9,11.8z
                M12,19.8c-2.7,0.9-5.7-0.6-6.6-3.3C4.6,13.8,6,10.8,8.7,9.9c2.7-0.9,5.7,0.6,6.6,3.3C16.2,15.9,14.7,18.9,12,19.8z M28.5,19.8
                c-2.7,0.9-5.7-0.6-6.6-3.3c-0.9-2.7,0.6-5.7,3.3-6.6c2.7-0.9,5.7,0.6,6.6,3.3C32.7,15.9,31.2,18.9,28.5,19.8z"/>
            </g>
            <g id="logo-name" v-if="!icon">
              <path d="M51.2,19.1v2.6h-1.5c-1.1,0-2-0.3-2.6-0.8c-0.6-0.5-0.9-1.4-0.9-2.6v-3.9H45v-2.5h1.2V9.4h3v2.4h2v2.5h-2v4
                c0,0.3,0.1,0.5,0.2,0.6s0.4,0.2,0.7,0.2H51.2z"/>
              <path d="M57.3,12.2c0.5-0.3,1.1-0.5,1.8-0.5v3.2h-0.8c-0.8,0-1.3,0.2-1.7,0.5s-0.6,0.9-0.6,1.7v4.6h-3v-9.9h3v1.7
                C56.3,12.9,56.7,12.5,57.3,12.2z"/>
              <path d="M60.7,10.3c-0.3-0.3-0.5-0.7-0.5-1.2c0-0.5,0.2-0.9,0.5-1.2s0.8-0.5,1.3-0.5c0.5,0,0.9,0.2,1.3,0.5
                c0.3,0.3,0.5,0.7,0.5,1.2c0,0.5-0.2,0.8-0.5,1.2c-0.3,0.3-0.8,0.5-1.3,0.5C61.5,10.8,61,10.6,60.7,10.3z M63.5,11.8v9.9h-3v-9.9
                H63.5z"/>
              <path d="M70,12.1c0.5-0.3,1.1-0.4,1.8-0.4c0.8,0,1.6,0.2,2.2,0.6c0.7,0.4,1.2,1,1.6,1.8c0.4,0.8,0.6,1.7,0.6,2.7
                s-0.2,1.9-0.6,2.7c-0.4,0.8-0.9,1.4-1.6,1.8c-0.7,0.4-1.4,0.6-2.2,0.6c-0.7,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.9-0.7-1.2-1.1v6.1h-3
                V11.8h3v1.4C69,12.7,69.5,12.4,70,12.1z M72.5,15c-0.4-0.4-0.9-0.6-1.6-0.6c-0.6,0-1.1,0.2-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.8
                c0,0.8,0.2,1.4,0.6,1.8c0.4,0.4,0.9,0.7,1.5,0.7s1.1-0.2,1.5-0.7s0.6-1,0.6-1.8C73.1,16,72.9,15.4,72.5,15z"/>
              <path d="M82,12.1c0.5-0.3,1.1-0.4,1.8-0.4c0.8,0,1.6,0.2,2.2,0.6c0.7,0.4,1.2,1,1.6,1.8c0.4,0.8,0.6,1.7,0.6,2.7
                s-0.2,1.9-0.6,2.7c-0.4,0.8-0.9,1.4-1.6,1.8c-0.7,0.4-1.4,0.6-2.2,0.6c-0.7,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.9-0.7-1.2-1.1v6.1h-3
                V11.8h3v1.4C81.1,12.7,81.5,12.4,82,12.1z M84.5,15c-0.4-0.4-0.9-0.6-1.6-0.6c-0.6,0-1.1,0.2-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.8
                c0,0.8,0.2,1.4,0.6,1.8c0.4,0.4,0.9,0.7,1.5,0.7s1.1-0.2,1.5-0.7s0.6-1,0.6-1.8C85.1,16,84.9,15.4,84.5,15z"/>
              <path d="M92.9,8.6v13.1h-3V8.6H92.9z"/>
              <path d="M105.2,11.8L99,26.4h-3.3l2.3-5l-4-9.6h3.4l2.3,6.2l2.3-6.2H105.2z"/>
            </g>
        </svg>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppLogo',
  props: {
    icon: Boolean
  }
})
</script>

<style lang="scss" scoped>
#app-logo {
    height: 2.25rem;
    svg {
      height: 100%;
    }
}
#logo-mark {
    fill: var(--color-primary);
}
#logo-name {
    fill: var(--text-color-primary);
}
</style>